import { render, staticRenderFns } from "./Masters.vue?vue&type=template&id=3f967767&lang=pug&"
import script from "./Masters.vue?vue&type=script&lang=ts&"
export * from "./Masters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports